<template>
    <b-modal style="overflow-y: auto;" v-model="show" no-close-on-esc no-close-on-backdrop hide-header-close>
        <h5 v-if="this.title !== null" slot="modal-header">
            {{this.title}}
        </h5>
        <slot name="content"><span class="font-weight-bold mb-5">{{$t('DELETE_DEFAULT_MSG')}}</span></slot>
        <div slot="modal-footer">
            <b-button  variant="danger" @click="confirmEvent" >
              <i :class="classValue"
                 aria-hidden="true"></i>
              <slot>{{$t('CONFIRM')}}</slot>
              </b-button>
            <b-button variant="link" @click="cancelEvent">{{$t('CANCEL')}}</b-button>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: "AppConfirmationDialog",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: null
            },
            id: {
                default: null
            },
          loading:{
              type:Boolean,
              default:false
          },
        },
        methods: {
            confirmEvent() {
                this.$emit('confirm', this.id)
            },
            cancelEvent() {
                this.$emit('cancel', this.id)
            }
        },
      computed:{
        classValue(){
          return this.loading ?  'fa fa-spinner fa-spin fa-fw' : ''
        },
      }
    }
</script>

<style scoped>

</style>
